const IGNORED_INCOMING_CALL_SESSION_TTL_MS = 30_000;
const CANCELLED_OUTGOING_CALL_SESSION_TTL_MS = 2 * 60_000;

const ignoredCallEndedSessions = new Map<string, number>();
const ignoredIncomingCallSessions = new Map<string, number>();
const cancelledOutgoingCallSessions = new Map<string, number>();

function cleanupExpired(map: Map<string, number>, now = Date.now()): void {
  for (const [sessionId, expiresAt] of map.entries()) {
    if (expiresAt <= now) {
      map.delete(sessionId);
    }
  }
}

export function shouldIgnoreCallEndedSession(callSessionId: string): boolean {
  const cleanCallSessionId = String(callSessionId || '').trim();
  if (!cleanCallSessionId) return false;

  const now = Date.now();
  cleanupExpired(ignoredCallEndedSessions, now);

  const expiresAt = ignoredCallEndedSessions.get(cleanCallSessionId);
  if (!expiresAt) return false;
  if (expiresAt <= now) {
    ignoredCallEndedSessions.delete(cleanCallSessionId);
    return false;
  }
  return true;
}

export function rememberIgnoredIncomingCallSession(callSessionId: string) {
  const cleanCallSessionId = String(callSessionId || '').trim();
  if (!cleanCallSessionId) return;
  ignoredIncomingCallSessions.set(cleanCallSessionId, Date.now() + IGNORED_INCOMING_CALL_SESSION_TTL_MS);
}

export function shouldIgnoreIncomingCallSession(callSessionId: string): boolean {
  const cleanCallSessionId = String(callSessionId || '').trim();
  if (!cleanCallSessionId) return false;

  const now = Date.now();
  cleanupExpired(ignoredIncomingCallSessions, now);

  const expiresAt = ignoredIncomingCallSessions.get(cleanCallSessionId);
  if (!expiresAt) return false;
  if (expiresAt <= now) {
    ignoredIncomingCallSessions.delete(cleanCallSessionId);
    return false;
  }
  return true;
}

export function rememberCancelledOutgoingCallSession(callSessionId: string) {
  const cleanCallSessionId = String(callSessionId || '').trim();
  if (!cleanCallSessionId) return;
  cleanupExpired(cancelledOutgoingCallSessions);
  cancelledOutgoingCallSessions.set(cleanCallSessionId, Date.now() + CANCELLED_OUTGOING_CALL_SESSION_TTL_MS);
}

export function forgetCancelledOutgoingCallSession(callSessionId: string) {
  const cleanCallSessionId = String(callSessionId || '').trim();
  if (!cleanCallSessionId) return;
  cancelledOutgoingCallSessions.delete(cleanCallSessionId);
}

export function shouldCancelOutgoingCallSession(callSessionId: string): boolean {
  const cleanCallSessionId = String(callSessionId || '').trim();
  if (!cleanCallSessionId) return false;

  const now = Date.now();
  cleanupExpired(cancelledOutgoingCallSessions, now);

  const expiresAt = cancelledOutgoingCallSessions.get(cleanCallSessionId);
  if (!expiresAt) return false;
  if (expiresAt <= now) {
    cancelledOutgoingCallSessions.delete(cleanCallSessionId);
    return false;
  }
  return true;
}
